import React, { FC } from 'react';
import { Divider as BaseDivider, DividerProps } from 'antd';
import cx from 'classnames';

import styles from './styles.module.css';

const Divider: FC<DividerProps> = ({ className, ...props }) => (
  <BaseDivider className={cx(styles.root, className)} {...props} />
);

export default Divider;
